
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { images } from '../../../../assets/images';
import { FeeBreakdownContent } from './FeeBreakdownContent';




interface LearnMoreModalProps {
    isOpen: boolean;
    toggle: () => void;
    field: string;
    fieldValue?: any;
}

const LearnMoreModal: React.FC<LearnMoreModalProps> = ({
    isOpen,
    toggle,
    field,
    fieldValue
}) => {
    const pageDetails = [
        {
            field: "showOtherFees",
            title: "Show processing fee and ticket fee breakdown to customers.",
            description: "<p>When enabled, customers will see the processing fee and ticket fee separately on the final booking page. When disabled, only the total fee will be displayed.</p>",
            image: images.learnMore.showOtherFees,
            link: null
        },
        {
            field: "isOtherAttendeeRequired",
            title: "Require information for all attendees.",
            description: "<p>When enabled, customers will see the processing fee and ticket fee separately on the final booking page. When disabled, only the total fee will be displayed.</",
            image: images.learnMore.isOtherAttendeeRequired,
            link: null
        },
        {
            field: "templateType",
            title: "Select a template for your event",
            description: "<p>We have two types of templates available one is <a href='https://eventox.co/event/corporate/13-baker-street' target='_blank' rel='noopener noreferrer'>corporate</a> and the other is <a href='https://eventox.co/event/entertainment/pakka-local-world-tour-new-zealand' target='_blank' rel='noopener noreferrer'>entertainment</a>.You can select the template based on your event type.</p>",
            image: null,
            link: null
        },
        {
            field: "multipleTicketGroups",
            title: "Multiple Ticket Groups",
            description: "<p>You can assign tickets to specific ticket groups. You can create a ticket group by clicking on the 'Add Ticket Group' button.</p>",
            image: images.learnMore.multipleTicketGroups,
            link: null
        },
        {
            field: "absorbFees",
            title: "Fee Structure Breakdown",
            description: "<p>Understanding how ticketing fees work and who pays them.</p>",
            image: null,
            link: null,
            customContent: true,
        }

    ]
    // Find the matching page details based on field
    const pageDetail = pageDetails.find(detail => detail.field === field);

    if (!pageDetail) {
        return null;
    }

    return (
        <Modal modalClassName="quick-v2-glass-modal" isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <h4 className="mb-0">{pageDetail.title}</h4>
            </ModalHeader>

            <ModalBody>
                <div className="learn-more-content">
                    {pageDetail.customContent ? (
                        <FeeBreakdownContent fieldValue={fieldValue} />
                    ) : (
                        <>
                            <div className="description mb-4" dangerouslySetInnerHTML={{ __html: pageDetail.description }} />

                            {pageDetail.image && (
                                <div className="image-container mb-4">
                                    <img
                                        src={pageDetail.image}
                                        alt={pageDetail.title}
                                        className="img-fluid rounded"
                                    />
                                </div>
                            )}

                            {pageDetail.link && (
                                <div className="learn-more-link">
                                    <a
                                        href={pageDetail.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-link p-0"
                                    >
                                        Learn more <i className="fas fa-external-link-alt ms-1"></i>
                                    </a>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};


export default LearnMoreModal;